// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dbdd8aa3","730":"85b676c7","754":"82db682f"}[chunkId] + ".chunk.js";
};